import { useContext, useEffect } from 'react';
import { Lobby } from './Lobby';
import { SearchForms } from './SearchForms';
import { SuppliersContext, resultsUrl } from 'Context/SuppliersContext';
import { ResultPages } from './ResultsPages';
import { useParams } from 'react-router-dom';
import { SUPPLIERS_STEPS } from 'Enum/suppliers';

export const SuppliersMain = () => {
  const { stepIndex, setStepIndex } = useContext(SuppliersContext);

  const { supplierCategory } = useParams();

  useEffect(() => {
    // TODO create switch to choose correct form type when more forms are added
    if (window.location.pathname.split('/').at(-1) !== resultsUrl) {
      if (supplierCategory) setStepIndex(1);
      else setStepIndex(0);
    } else setStepIndex(2);
  }, [setStepIndex, supplierCategory]);

  const getStepContent = () => {
    switch (stepIndex) {
      default:
      case SUPPLIERS_STEPS.LOBBY:
        return <Lobby />;

      case SUPPLIERS_STEPS.FORM:
        return <SearchForms />;

      case SUPPLIERS_STEPS.RESULTS:
        return <ResultPages />;
    }
  };

  return getStepContent();
};
